export default __webpack_public_path__ + "109893ddfcc681fc060f5b7ceda5aaec.png";